export default __webpack_public_path__ + "static/media/icn-help-on.6553042e.svg";